module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_3.6e9c48c7.png";